import React, { useState, useEffect } from 'react';
import Table from '../components/Table/Table';
import TopNavbar from '../components/TopNavbar/TopNavbar';
import ApiManager from '../ApiManager/ApiManager';
import NewTax from './NewTax';
import SearchBar from '../components/SearchBar/SearchBar';
import Modal from '../components/Modal/Modal';
import ViewEntity from '../components/ViewEntity/ViewEntity';
import EditEntity from '../components/EditEntity/EditEntity';
import { useAuth } from '../components/AuthProvider';
import PERMISSIONS from '../permissions';
import { hasPermission, ShowButton } from '../components/RoleBasedComponents';
import { useComponentLoading } from '../utils/useComponentLoading';

function Taxes() {
  const {userPermissions} = useAuth();
  const { withLoading, isLoading, getMessage, getProgress } = useComponentLoading();

  const [data, setData] = useState([]);
  const [rowId, setRowId] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isDetails, setDetails] = useState(true);
  const [isEdit, setEdit] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMorePages, setHasMorePages] = useState(true);

  useEffect(() => {
    fetchData();
  }, [currentPage]);

  const fetchData = async () => {
    try {
      await withLoading('fetchTaxes', async (onProgress) => {
        onProgress(20, 'Fetching tax types...');
        const params = new URLSearchParams({
          page_size: 12,
          page: currentPage,
        });
        const response = await ApiManager.getAllTaxes(params);
        onProgress(60, 'Processing data...');
        if (!response.ok) throw new Error('failed to fetch taxes');
        const json = await response.json();
        console.log('res', json);
        setData(json);
        setHasMorePages(json.length == 12);
        onProgress(100, 'Completed');
      });
    } catch (error) {
      console.log('error', error);
      setHasMorePages(false);
    }
  };

  const toggleModal = () => {
    setModalOpen(!isModalOpen);
  };

  const handleEdit = () => {
    console.log('Edit clicked for row:');
    setDetails(false);
    setEdit(true);
    setModalOpen(true);
  };

  const handleDetails = () => {
    console.log('Details clicked for row:');
    setDetails(true);
    setEdit(false);
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const buttons = [
    { label: 'Details', onClick: () => handleDetails() },
  ];

  if (hasPermission(userPermissions, PERMISSIONS.VENDOR_TAX_TYPE_UPDATE)) {
    buttons.push({ label: 'Edit', onClick: () => handleEdit() });
  }

  const columns = [
    { field: 'name', headerName: 'Type' },
    { field: 'percentage', headerName: 'Percentage (%)' },
  ];

  const rows = (data || []).map(item => ({
    id: item.id,
    name: item.name,
    percentage: item.percentage,
  }));

  return (
    <div>
      <TopNavbar
        title="Taxes"
      />
      <div
        style={{
          display: 'flex',
          justifyContent: 'right',
          width: '100%',
          paddingTop: '20px',
          height: '5vh',
        }}
      >
        {/* <SearchBar /> */}
        <ShowButton permission={PERMISSIONS.VENDOR_TAX_TYPE_CREATE}>
          <NewTax onSuccess={fetchData}/>
        </ShowButton>
      </div>

      <Table 
        table_columns={columns} 
        view_columns={columns} 
        rows={rows} 
        entity="taxTypeId"
        setRowsId={setRowId}
        fetchFunction={ApiManager.getTaxType}
        updateFunction={ApiManager.updateTaxType}
        buttons={buttons}
        setCurrentPage={setCurrentPage}
        currentPage={currentPage}
        hasMorePages={hasMorePages}
        isLoading={isLoading('fetchTaxes')}
        loadingMessage={getMessage('fetchTaxes')}
        loadingProgress={getProgress('fetchTaxes')}
      />

      {isModalOpen && isDetails && (
        <Modal isOpen={true} onClose={handleModalClose}>
          <ViewEntity
            id={rowId}
            fetchFunction={ApiManager.getTaxType}
            columns={columns}
            entity="taxTypeId"
          />
        </Modal>
      )}
      {isModalOpen && isEdit && (
        <Modal isOpen={true} onClose={handleModalClose}>
          <EditEntity
            id={rowId}
            updateFunction={ApiManager.updateTaxType}
            columns={columns}
            entity="taxTypeId"
            fetchFunction={ApiManager.getTaxType}
            toggleFunction={toggleModal}
          />
        </Modal>
      )}
    </div>
  );
}

export default Taxes;
